export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  categorySlug: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  description: string;
  chapters: Chapter[];
  updateTime: string;
  tags: string[];
}

export interface Chapter {
  id: string;
  title: string;
  number: number;
  updateTime: string;
}

export interface Category {
  name: string;
  slug: string;
  count: number;
  icon: string;
}

export const categories: Category[] = [
  { name: '热门连载', slug: 'hot', count: 128, icon: 'ri-fire-line' },
  { name: '最新上架', slug: 'new', count: 56, icon: 'ri-sparkling-line' },
  { name: '完结漫画', slug: 'completed', count: 340, icon: 'ri-check-double-line' },
  { name: '恋爱漫画', slug: 'romance', count: 215, icon: 'ri-heart-line' },
  { name: '奇幻漫画', slug: 'fantasy', count: 189, icon: 'ri-magic-line' },
  { name: '动作漫画', slug: 'action', count: 167, icon: 'ri-sword-line' },
  { name: '悬疑漫画', slug: 'thriller', count: 98, icon: 'ri-search-eye-line' },
  { name: '治愈漫画', slug: 'healing', count: 76, icon: 'ri-emoji-sticker-line' },
];

export const comics: Comic[] = [
  {
    id: 'comic-01',
    title: '我独自升级',
    author: 'Chugong / DUBU（REDICE STUDIO）',
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20webtoon%20cover%20art%2C%20dark%20fantasy%20style%2C%20a%20powerful%20male%20protagonist%20with%20glowing%20purple%20eyes%20in%20a%20dark%20hood%2C%20shadow%20soldiers%20behind%20him%2C%20epic%20atmosphere%2C%20dramatic%20lighting%2C%20professional%20digital%20illustration%2C%20simple%20dark%20gradient%20background%2C%20warm%20accent%20highlights&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    category: '动作漫画',
    categorySlug: 'action',
    status: '连载中',
    rating: 9.7,
    views: 18500000,
    description: '十年前，神秘的地下城突然出现在世界各地。作为人类最弱的E级猎人，成振宇每天都在危险的地下城中艰难求生。然而在一次地下城事故中，他意外获得了"系统"的力量，成为了唯一能够无限升级的"玩家"。从此他的命运彻底改变，用实力一步步从最弱者成长为最强者。这是一部关于成长的史诗级故事，融合了精彩的动作场面和深刻的人物刻画。',
    chapters: [
      { id: 'ch-01-01', title: '第1话 最弱的猎人', number: 1, updateTime: '2026-08-01' },
      { id: 'ch-01-02', title: '第2话 系统的觉醒', number: 2, updateTime: '2026-08-02' },
      { id: 'ch-01-03', title: '第3话 第一次升级', number: 3, updateTime: '2026-08-03' },
      { id: 'ch-01-04', title: '第4话 影之军团', number: 4, updateTime: '2026-08-04' },
    ],
    updateTime: '2026-08-04',
    tags: ['热血', '升级', '奇幻', '战斗'],
  },
  {
    id: 'comic-02',
    title: '女神降临',
    author: 'Yaongyi',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20romance%20cover%2C%20a%20stunning%20young%20woman%20with%20long%20dark%20hair%20and%20perfect%20makeup%2C%20half%20of%20her%20face%20showing%20natural%20beauty%2C%20soft%20pink%20and%20warm%20tones%2C%20dreamy%20atmosphere%2C%20Korean%20manhwa%20illustration%20style%2C%20simple%20light%20cream%20background%2C%20delicate%20details&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    category: '恋爱漫画',
    categorySlug: 'romance',
    status: '连载中',
    rating: 9.5,
    views: 22300000,
    description: '因为长相平凡而在学校备受欺凌的林珠璟，通过化妆成为了校园女神。当她在高中生活中同时遇到冷漠毒舌的李秀豪和温柔的韩书俊，一段充满甜蜜与纠结的三角恋爱故事就此展开。这部漫画不仅讲述了浪漫的爱情故事，更探讨了自信与自我认同的主题。',
    chapters: [
      { id: 'ch-02-01', title: '第1话 全新的开始', number: 1, updateTime: '2026-08-01' },
      { id: 'ch-02-02', title: '第2话 两个他', number: 2, updateTime: '2026-08-02' },
      { id: 'ch-02-03', title: '第3话 秘密', number: 3, updateTime: '2026-08-03' },
    ],
    updateTime: '2026-08-03',
    tags: ['恋爱', '校园', '成长', '日常'],
  },
  {
    id: 'comic-03',
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    cover: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20webtoon%20cover%2C%20a%20mysterious%20male%20character%20reading%20a%20glowing%20book%2C%20apocalyptic%20cityscape%20silhouette%20in%20background%2C%20golden%20and%20warm%20brown%20tones%2C%20epic%20fantasy%20illustration%2C%20simple%20dark%20gradient%20background%2C%20professional%20digital%20art&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    category: '奇幻漫画',
    categorySlug: 'fantasy',
    status: '连载中',
    rating: 9.8,
    views: 16200000,
    description: '作为唯一读完长达3149话的网络小说《灭活法》的读者，金独子在一个平凡的日子里，发现小说里的世界变成了现实。凭借对剧情的了解，他必须在末日中生存下去。然而事情的发展逐渐偏离了原作的轨道，他能否利用自己的知识改变这个世界的命运？',
    chapters: [
      { id: 'ch-03-01', title: '第1话 小说的终结', number: 1, updateTime: '2026-08-01' },
      { id: 'ch-03-02', title: '第2话 世界变了', number: 2, updateTime: '2026-08-02' },
      { id: 'ch-03-03', title: '第3话 第一个场景', number: 3, updateTime: '2026-08-03' },
    ],
    updateTime: '2026-08-03',
    tags: ['奇幻', '末世', '生存', '智斗'],
  },
  {
    id: 'comic-04',
    title: '她的沈清',
    author: 'Seri / Biwan',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20historical%20Korean%20webtoon%20cover%2C%20two%20women%20in%20traditional%20Korean%20hanbok%20dresses%2C%20one%20in%20bright%20colors%20and%20one%20in%20simple%20attire%2C%20soft%20watercolor%20style%2C%20warm%20peach%20and%20cream%20tones%2C%20elegant%20atmosphere%2C%20simple%20light%20background&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    category: '恋爱漫画',
    categorySlug: 'romance',
    status: '已完结',
    rating: 9.6,
    views: 8900000,
    description: '在古代朝鲜的一个小村庄里，沈清为了拯救失明的父亲而被迫嫁给海神作祭品。与此同时，一位厌倦宫廷生活的贵女也在逃避自己的命运。两个身份迥异的女子因缘际会走到了一起，在彼此身上找到了从未有过的温暖与力量。这是一个关于爱、勇气与自我救赎的感人故事。',
    chapters: [
      { id: 'ch-04-01', title: '第1话 祭品', number: 1, updateTime: '2026-07-15' },
      { id: 'ch-04-02', title: '第2话 逃婚的贵女', number: 2, updateTime: '2026-07-16' },
      { id: 'ch-04-03', title: '第3话 相遇', number: 3, updateTime: '2026-07-17' },
    ],
    updateTime: '2026-07-17',
    tags: ['古风', '百合', '治愈', '成长'],
  },
  {
    id: 'comic-05',
    title: '看脸时代',
    author: '朴泰俊',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20cover%20showing%20a%20split%20face%20concept%2C%20one%20side%20showing%20an%20overweight%20teenager%20and%20the%20other%20side%20a%20handsome%20fit%20young%20man%2C%20warm%20amber%20and%20orange%20tones%2C%20dramatic%20contrast%2C%20modern%20Korean%20manhwa%20style%2C%20simple%20neutral%20background&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    category: '动作漫画',
    categorySlug: 'action',
    status: '连载中',
    rating: 9.4,
    views: 25600000,
    description: '朴亨锡是一个因为肥胖长相而长期遭受校园霸凌的高中生。某天醒来后，他发现自己拥有了一个完美的身体。从此他白天用这副完美的身体生活，晚上则回到原本的身体。通过两个身体的切换，他逐渐看清了这个"看脸"的世界的真相，也踏上了追求正义的道路。',
    chapters: [
      { id: 'ch-05-01', title: '第1话 两个身体', number: 1, updateTime: '2026-08-01' },
      { id: 'ch-05-02', title: '第2话 新学校', number: 2, updateTime: '2026-08-02' },
      { id: 'ch-05-03', title: '第3话 第一次出手', number: 3, updateTime: '2026-08-03' },
    ],
    updateTime: '2026-08-03',
    tags: ['校园', '格斗', '成长', '社会'],
  },
  {
    id: 'comic-06',
    title: '甜蜜家园',
    author: '金坎比 / 黄英璨',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20horror%20Korean%20webtoon%20cover%2C%20a%20teenager%20looking%20fearfully%20through%20a%20cracked%20apartment%20door%2C%20monstrous%20shadows%20looming%20in%20the%20dark%20hallway%2C%20warm%20amber%20light%20from%20inside%20contrasting%20with%20darkness%2C%20suspenseful%20atmosphere%2C%20simple%20dark%20background&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    category: '悬疑漫画',
    categorySlug: 'thriller',
    status: '已完结',
    rating: 9.5,
    views: 19800000,
    description: '在经历家庭悲剧后，车贤秀搬到了一栋破旧的公寓大楼。然而当整个世界开始被一种神秘病毒侵袭，人类开始变异成可怕的怪物时，这座公寓成为了幸存者的最后避难所。被困在公寓中的居民们必须团结一致，对抗门外日益增多的怪物，同时还要面对人性本身最黑暗的一面。',
    chapters: [
      { id: 'ch-06-01', title: '第1话 新家', number: 1, updateTime: '2026-07-20' },
      { id: 'ch-06-02', title: '第2话 门外的声音', number: 2, updateTime: '2026-07-21' },
      { id: 'ch-06-03', title: '第3话 第一位邻居', number: 3, updateTime: '2026-07-22' },
    ],
    updateTime: '2026-07-22',
    tags: ['恐怖', '末世', '生存', '人性'],
  },
  {
    id: 'comic-07',
    title: '懒人',
    author: 'JQ / Akeo Studio',
    cover: 'https://readdy.ai/api/search-image?query=A%20whimsical%20Korean%20webtoon%20cover%2C%20a%20young%20man%20laying%20lazily%20on%20a%20sofa%20surrounded%20by%20magical%20sparkles%2C%20cozy%20warm%20room%20atmosphere%2C%20soft%20coral%20and%20cream%20tones%2C%20lighthearted%20mood%2C%20Korean%20manhwa%20style%2C%20simple%20warm%20background&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    category: '治愈漫画',
    categorySlug: 'healing',
    status: '连载中',
    rating: 9.2,
    views: 5600000,
    description: '这是一个关于"韩漫大全"世界里最懒之人的故事。主角李贤宇的人生信条只有三个字——"好麻烦"。然而当他意外遇到了行动力爆表的元气少女金多美后，他的日常开始被彻底颠覆。一部轻松搞笑又带点温馨的日常漫画，看完之后让人忍不住想……继续躺着。',
    chapters: [
      { id: 'ch-07-01', title: '第1话 今天也不想出门', number: 1, updateTime: '2026-08-04' },
      { id: 'ch-07-02', title: '第2话 麻烦的邻居', number: 2, updateTime: '2026-08-04' },
    ],
    updateTime: '2026-08-04',
    tags: ['搞笑', '日常', '恋爱', '轻松'],
  },
  {
    id: 'comic-08',
    title: '神之塔',
    author: 'SIU',
    cover: 'https://readdy.ai/api/search-image?query=A%20grand%20fantasy%20Korean%20webtoon%20cover%2C%20a%20towering%20mysterious%20structure%20reaching%20into%20the%20clouds%2C%20a%20young%20boy%20with%20determined%20eyes%20standing%20at%20the%20base%2C%20epic%20scale%2C%20warm%20golden%20light%20from%20above%2C%20adventure%20atmosphere%2C%20simple%20dark%20gradient%20background&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    category: '奇幻漫画',
    categorySlug: 'fantasy',
    status: '连载中',
    rating: 9.6,
    views: 31200000,
    description: '传说中，登上塔顶的人可以获得任何他想要的东西。少年二十五夜为了追寻唯一的挚友——少女蕾哈尔，进入了这座神秘的高塔。在塔中他遇到了各种奇异的试炼和形形色色的伙伴，逐步揭开了塔的秘密和自己的身世之谜。一部融合了冒险、战斗和友情的宏大叙事。',
    chapters: [
      { id: 'ch-08-01', title: '第1话 进入塔中', number: 1, updateTime: '2026-08-01' },
      { id: 'ch-08-02', title: '第2话 最初的试炼', number: 2, updateTime: '2026-08-02' },
      { id: 'ch-08-03', title: '第3话 王冠游戏', number: 3, updateTime: '2026-08-03' },
      { id: 'ch-08-04', title: '第4话 新的伙伴', number: 4, updateTime: '2026-08-04' },
    ],
    updateTime: '2026-08-04',
    tags: ['奇幻', '冒险', '战斗', '友情'],
  },
  {
    id: 'comic-09',
    title: '某天成为公主',
    author: 'Plutus / Spoon',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20fantasy%20cover%2C%20a%20young%20princess%20with%20long%20blonde%20hair%20and%20shining%20blue%20eyes%20in%20an%20elegant%20pink%20dress%2C%20castle%20silhouette%20background%2C%20sparkling%20magical%20atmosphere%2C%20warm%20peach%20tones%2C%20fairy%20tale%20style%2C%20simple%20light%20background&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    category: '奇幻漫画',
    categorySlug: 'fantasy',
    status: '连载中',
    rating: 9.3,
    views: 14500000,
    description: '一觉醒来，我竟然成为了小说中那个命运悲惨的公主阿塔纳西娅。更糟糕的是，在小说的结局里我会被自己的亲生父亲——冷酷无情的皇帝处死！为了改写这个悲惨的命运，我必须从现在开始努力在父皇面前刷存在感。然而事情似乎并不像小说中写的那样简单……',
    chapters: [
      { id: 'ch-09-01', title: '第1话 穿越成公主', number: 1, updateTime: '2026-08-02' },
      { id: 'ch-09-02', title: '第2话 面见父皇', number: 2, updateTime: '2026-08-03' },
      { id: 'ch-09-03', title: '第3话 意外的温暖', number: 3, updateTime: '2026-08-04' },
    ],
    updateTime: '2026-08-04',
    tags: ['奇幻', '穿越', '亲情', '宫廷'],
  },
  {
    id: 'comic-10',
    title: '再婚皇后',
    author: 'Alphatart / Sumpul',
    cover: 'https://readdy.ai/api/search-image?query=A%20gorgeous%20Korean%20webtoon%20historical%20romance%20cover%2C%20a%20majestic%20queen%20in%20an%20elaborate%20golden%20royal%20hanbok%2C%20cold%20yet%20elegant%20expression%2C%20palace%20interior%20with%20warm%20candlelight%2C%20dramatic%20tension%2C%20regal%20atmosphere%2C%20simple%20dark%20gold%20background&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    category: '恋爱漫画',
    categorySlug: 'romance',
    status: '连载中',
    rating: 9.5,
    views: 17800000,
    description: '娜维尔是东方帝国的皇后，为了帝国的稳定，她容忍着丈夫带着情妇住进宫中。当一切都忍无可忍时，她做了一个大胆的决定——接受邻国的联姻请求，成为西方王国的皇后。然而她不知道的是，这个决定将彻底改变她的人生轨迹。一部关于女性觉醒和真爱的史诗故事。',
    chapters: [
      { id: 'ch-10-01', title: '第1话 皇后的忍耐', number: 1, updateTime: '2026-08-01' },
      { id: 'ch-10-02', title: '第2话 决定', number: 2, updateTime: '2026-08-02' },
      { id: 'ch-10-03', title: '第3话 再婚', number: 3, updateTime: '2026-08-03' },
    ],
    updateTime: '2026-08-03',
    tags: ['宫廷', '恋爱', '女性', '逆袭'],
  },
  {
    id: 'comic-11',
    title: '极限',
    author: '金圭森',
    cover: 'https://readdy.ai/api/search-image?query=An%20intense%20Korean%20webtoon%20action%20cover%2C%20a%20fighter%20in%20martial%20arts%20stance%20with%20bloodied%20knuckles%2C%20school%20uniform%20torn%2C%20fierce%20determination%20in%20eyes%2C%20warm%20amber%20and%20crimson%20dynamic%20composition%2C%20street%20fight%20aesthetic%2C%20simple%20dark%20background&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    category: '动作漫画',
    categorySlug: 'action',
    status: '连载中',
    rating: 9.1,
    views: 7800000,
    description: '在这个弱肉强食的高中里，朴志勋用自己的拳头守护着一切。当他转入传说中的"格斗高中"后，才发现真正的战斗才刚刚开始。面对来自全国各地的格斗天才们，他必须不断突破自己的极限。血与汗交织的校园格斗传奇！',
    chapters: [
      { id: 'ch-11-01', title: '第1话 转校生', number: 1, updateTime: '2026-08-03' },
      { id: 'ch-11-02', title: '第2话 初战', number: 2, updateTime: '2026-08-04' },
    ],
    updateTime: '2026-08-04',
    tags: ['格斗', '校园', '热血', '竞技'],
  },
  {
    id: 'comic-12',
    title: '月光雕刻师',
    author: '李度贤',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20webtoon%20cover%2C%20a%20mysterious%20sculptor%20creating%20glowing%20moonlight%20art%20in%20a%20VR%20game%20world%2C%20magical%20forest%20with%20floating%20lights%2C%20dreamy%20silver%20and%20warm%20gold%20tones%2C%20adventure%20game%20atmosphere%2C%20simple%20dark%20background&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    category: '奇幻漫画',
    categorySlug: 'fantasy',
    status: '连载中',
    rating: 9.4,
    views: 12300000,
    description: '在虚拟现实游戏"皇家之路"中，李贤是一个选择了最不受欢迎的"雕刻师"职业的玩家。当所有人都认为这个职业毫无用处时，他却发现了雕刻师职业背后隐藏的惊人秘密。月光下诞生的雕刻作品，将改变整个游戏的格局！',
    chapters: [
      { id: 'ch-12-01', title: '第1话 进入皇家之路', number: 1, updateTime: '2026-08-01' },
      { id: 'ch-12-02', title: '第2话 雕刻师的秘密', number: 2, updateTime: '2026-08-02' },
      { id: 'ch-12-03', title: '第3话 第一件作品', number: 3, updateTime: '2026-08-03' },
    ],
    updateTime: '2026-08-03',
    tags: ['游戏', '奇幻', '冒险', '升级'],
  },
];

export const faqItems = [
  {
    question: '韩漫大全是什么？',
    answer: '韩漫大全是一个专注于韩国漫画在线阅读的综合平台，我们为广大华语读者提供最新、最全、最高质量的韩国漫画资源。无论是热门连载、经典完结，还是小众佳作，您都能在这里找到。',
  },
  {
    question: '韩漫大全上的漫画都是免费的吗？',
    answer: '是的，韩漫大全上的所有韩国漫画资源均完全免费提供在线阅读，无需付费，无需订阅。我们致力于让每一位热爱韩漫的读者都能无门槛地享受精彩的漫画内容。',
  },
  {
    question: '韩漫大全的更新频率如何？',
    answer: '我们的编辑团队每日跟进韩国漫画的最新动态，确保热门连载漫画能够第一时间更新到网站上。通常热门连载作品会在韩文原版发布后24小时内完成翻译更新。',
  },
  {
    question: '如何找到我想看的特定漫画？',
    answer: '您可以通过以下几种方式查找漫画：1）使用页面顶部的搜索功能输入漫画名或作者名；2）通过分类页面按类型（恋爱、奇幻、动作等）浏览；3）在首页查看热门排行榜和最新更新列表。',
  },
  {
    question: '韩漫大全支持手机阅读吗？',
    answer: '韩漫大全网站采用了响应式设计，完美适配手机、平板和电脑等各种设备。您可以在任何设备上通过浏览器访问我们的网站，享受流畅的阅读体验。',
  },
  {
    question: '为什么有些漫画只更新了一部分？',
    answer: '韩国漫画通常以连载形式发布，每周或每两周更新一话。我们的翻译团队会紧跟韩文原版的更新进度，确保以最快速度为您带来最新内容。您可以关注我们的更新通知，不会错过任何精彩章节。',
  },
];

export const siteInfo = {
  name: '韩漫大全',
  tagline: '好看韩国漫画免费在线阅读平台',
  description: '韩漫大全致力于为华语读者提供最优质的韩国漫画阅读体验。每日更新、免费阅读、分类齐全，是您看韩漫的最佳选择。',
  stats: {
    totalComics: '5,200+',
    dailyVisitors: '50万+',
    monthlyUpdates: '3,000+',
    userSatisfaction: '98.5%',
  },
};